import { jsx as _jsx } from "react/jsx-runtime";
import { logger } from '@lichtblick/logger';
import { useTracker } from '@lichtblick/tracker';
import { createContext, useContext, useEffect } from 'react';
export const AKLAMIO_SESSION_STORAGE_NAME = 'aklamioId';
const additionalCustomPropsMap = {
    APARTMENT_BUILDING: {
        reasonParked: 'APARTMENT_BUILDING'
    },
    COMMERCIAL_BUILDING: {
        reasonParked: 'COMMERCIAL_BUILDING'
    },
    MISSING_INSTALLATION_PARTNER: {
        reasonParked: 'MISSING_INSTALLATION_PARTNER',
        partner: false
    },
    UNSUPPORTED_ROOF_MATERIAL: {
        reasonParked: 'UNSUPPORTED_ROOF_MATERIAL'
    }
};
export const createFailureEvent = (funnelState)=>({
        eventName: 'form_failed',
        customProps: {
            form_name: 'Solar Request',
            error_message: funnelState.errors?.generic,
            ...funnelState.reasonParked ? additionalCustomPropsMap[funnelState.reasonParked] : {
                partner: true
            }
        }
    });
export const createSuccessEvent = ({ reasonParked, requestId, sha256_email_address })=>({
        sha256_email_address,
        eventName: 'form_submit_solar_request',
        customProps: {
            unique_id: requestId,
            ...reasonParked ? additionalCustomPropsMap[reasonParked] : {
                partner: true
            }
        }
    });
const virtPageTitleDictionary = {
    unsupportedRoofMaterial: 'Embedded Solar Request Dachmaterial nicht unterstuetzt',
    postalCode: undefined,
    houseType: 'Embedded Solar Request Haustyp',
    unsupportedRegion: 'Embedded Solar Request Kein Fachpartner',
    roofMaterial: 'Embedded Solar Request Dachmaterial',
    name: 'Embedded Solar Request Name',
    address: 'Embedded Solar Request Adresse',
    phoneNumber: 'Embedded Solar Request Telefonnummer',
    comment: 'Embedded Solar Request Kommentar',
    email: 'Embedded Solar Request E-Mail'
};
export const PageMetaContext = /*#__PURE__*/ createContext({
    pageArea: 'EaaS',
    pageType: 'product'
});
export const PageMetaProvider = ({ children, value })=>/*#__PURE__*/ _jsx(PageMetaContext.Provider, {
        value: value,
        children: children
    });
export const useStepTracking = (funnelState)=>{
    const pageMetaClassification = useContext(PageMetaContext);
    const { trackPageMetaEvent, trackVirtPathEvent } = useTracker();
    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
    useEffect(()=>{
        const virtPageTitle = virtPageTitleDictionary[funnelState.currentStep];
        logger.info(`EMBEDDED_SOLAR_FUNNEL: Entering Step ${funnelState.currentStep}`);
        if (virtPageTitle) {
            const virtPagePath = `/${virtPageTitle.replace(/\s/g, '-').toLowerCase()}/`;
            // Page and Virtual Path tracking
            trackVirtPathEvent({
                virtPagePath,
                virtPageTitle
            });
            trackPageMetaEvent(pageMetaClassification);
        }
    }, [
        funnelState.currentStep
    ]);
};

//# sourceMappingURL=b2c-funnel-embed.tracking.js.map